module.exports = __webpack_public_path__ + "img/dhhb.67767b98.png";